import React from "react";
import SearchListItem from "../../../Features/Search/Views/SearchListItem";
import QuickLink from "../../Models/QuickLink";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Image from "material-ui-image/lib/components/Image/Image";
import ListItemText from "@material-ui/core/ListItemText";
import markup from "../../Helper/markup";
import FavoritesButton from "../Buttons/FavoritesButton";
import {ListItemSecondaryAction} from "@material-ui/core";
import ListItemProps from "../../Models/ListItemProps";
import ItemType from "../../Models/ItemType";

const QuickLinkSearchItem = (props: ListItemProps<QuickLink>) => {
    const {item, displayFavorite, isFavorite, onClick, onClickFavorite, onClickFavoriteItem, showDivider} = props;
    return (
        <SearchListItem
            divider={showDivider}
            onClick={() => {
                    if (onClick)
                        onClick(item);
                }
            }
        >
            <ListItemAvatar>
                <Image
                    animationDuration={1000}
                    src={item.iconURL || ""}
                    disableSpinner={true}
                    style={{height: 40, width: 40, paddingTop: 0}}
                    imageStyle={{height: 40, width: 40, borderRadius: 20}}
                />
            </ListItemAvatar>
            <ListItemText
                primary={<div
                    dangerouslySetInnerHTML={markup(item.title)}
                />}
            />
            {displayFavorite &&
            <ListItemSecondaryAction>
                <FavoritesButton
                    onClick={() => {
                            if (onClickFavorite)
                                onClickFavorite(item.id, ItemType.QuickLink);

                            if (onClickFavoriteItem)
                                onClickFavoriteItem(item);
                        }
                    }
                    selected={isFavorite || false}
                    />
            </ListItemSecondaryAction>
            }
        </SearchListItem>
    );
};

export default QuickLinkSearchItem;